module.exports = "<div class=product-name> <small ng-if=displayName> {{ displayName }} </small> <span class=description> {{ description }} </span> </div>";